/**
 * Prototype filterNull
 * Filter null values (e.q. neither undefined or null or empty string or zero value (0))
 */
if (!Array.prototype.filterNull) {
    Array.prototype.filterNull = function<T>(): Array<NonNullable<T>> {
      return this.filter((item: T | undefined | null): item is T => !!item) as Array<NonNullable<T>>
    }
}
